import { render } from "./ClientShowView.vue?vue&type=template&id=6b826b68&scoped=true"
import script from "./ClientShowView.vue?vue&type=script&lang=js"
export * from "./ClientShowView.vue?vue&type=script&lang=js"

import "./ClientShowView.vue?vue&type=style&index=0&id=6b826b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b826b68"]])

export default __exports__